<template>
  <div class="container" ref="container">
    <el-row ref="conditionRow">
      <el-col :span="24">
        <div class="grid-content searchTitle">
          <span>设备名称</span>
          <el-input
            v-model="emNameVal"
            :style="{ width: '200px', marginLeft: '10px' }"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="control-btn">
          <a @click="getCemsData()" style="margin-left: 30px" class="self_btn"
            >查询</a
          >
          <a @click="clearCemsArgs()" class="self_btn">重置</a>
        </div>
      </el-col>
      <!--el-col :span="5">
        <div class="grid-content" @click="searchDataSource">
          <el-button>查询</el-button>
        </div>

      </el-col-->
      <!--el-col :span="3">
        <div class="grid-content" @click="resetDataSource">
          <el-button :style="{ marginLeft: '10px' }">重置</el-button>
        </div>
      </el-col-->
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="list"
          :header-cell-class-name="getHeaderCellClass"
          :header-row-class-name="getHeadRowClass"
          :cell-class-name="getCellClass"
          :row-class-name="getRowClass"
          class="cems_table"
          ref="sourceTable"
          v-loading="isLoad"
          :element-loading-text="loadStr"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
          :style="{ marginTop: '10px' }"
          :maxHeight="autoHeight"
        >
          <el-table-column label="序号" width="45">
            <template #default="scope">
              <span :class="reactIndex" v-if="scope.row.no">{{
                scope.row.no
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="设备名称" width="230">
            <template #default="scope">
              <span :class="reactName">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="SO2">
            <el-table-column label="(mg/m³)">
              <template #default="scope">
                <template v-if="scope.row.no > 0">
                  <span :class="compareCems(scope.row.so2, scope.row.gbSo2)">{{
                    !isNaN(scope.row.so2)
                      ? parseFloat(scope.row.so2).toFixed(2)
                      : scope.row.so2
                  }}</span
                  ><span class="splitTag">|</span
                  ><span class="number standardSize">{{
                    scope.row.gbSo2
                  }}</span>
                </template>
                <template v-else>
                  <span :class="reactTitle">{{
                    !isNaN(scope.row.so2)
                      ? parseFloat(scope.row.so2).toFixed(2)
                      : scope.row.so2
                  }}</span>
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="颗粒物">
            <el-table-column label="(mg/m³)">
              <template #default="scope">
                <template v-if="scope.row.no > 0">
                  <span :class="compareCems(scope.row.klw, scope.row.gbTdc)">{{
                    !isNaN(scope.row.klw)
                      ? parseFloat(scope.row.klw).toFixed(2)
                      : scope.row.klw
                  }}</span
                  ><span class="splitTag">|</span
                  ><span class="number standardSize">{{
                    scope.row.gbTdc
                  }}</span>
                </template>
                <template v-else>
                  <span :class="reactTitle">{{
                    !isNaN(scope.row.klw)
                      ? parseFloat(scope.row.klw).toFixed(2)
                      : scope.row.klw
                  }}</span>
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="NOX">
            <el-table-column label="(mg/m³)">
              <template #default="scope">
                <template v-if="scope.row.no > 0">
                  <span :class="compareCems(scope.row.nox, scope.row.gbNox)">{{
                    !isNaN(scope.row.nox)
                      ? parseFloat(scope.row.nox).toFixed(2)
                      : scope.row.nox
                  }}</span
                  ><span class="splitTag">|</span
                  ><span class="number standardSize">{{
                    scope.row.gbNox
                  }}</span>
                </template>
                <template v-else>
                  <span :class="reactTitle">{{
                    !isNaN(scope.row.nox)
                      ? parseFloat(scope.row.nox).toFixed(2)
                      : scope.row.nox
                  }}</span>
                </template>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'cemsDataListTiny.vue',
      computedName: '有组织cems监控数据组件',
      list: [],
      autoHeight: 620,
      equipmentName: "",
      governmentName: "",
      monitorName: "",
      input: "",
      pageNo: 1,
      pageSize: 100,
      total: "",
      emNameVal: "",
      isLoad: false,
      loadStr: "拼命加载中",
      delayLoader: "",
      curPage: 1,
      scrollPage: 1,
      scrollPageTimer: "",
      timer: null,
      customerId: this.$store.state.customerId,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getHeaderCellClass() {
      return function (obj) {
        if (obj.rowIndex === 0) {
          if (obj.columnIndex === 0) {
            if (!obj.rowIndex) {
              return "thClass";
            } else {
              return "thClass_";
            }
          } else {
            return "thClass";
          }
        } else if (obj.rowIndex === 1) {
          return "thClass__";
        }
      };
    },

    getHeadRowClass() {
      return function (obj) {
        return "headTrClass";
      };
    },

    getCellClass() {
      let that = this;
      return function (obj) {
        if (obj.columnIndex === 0) {
          if (that.customerId == 66) {
            return "thClass_baogang";
          } else {
            return "tdClass_";
          }
        } else {
          return "tdClass";
        }
      };
    },

    getRowClass() {
      return function (obj) {
        return "trClass";
      };
    },

    compareCems() {
      let className = "number numberSize";
      return function (val, gb) {
        if (val && !isNaN(val)) {
          if (val <= gb * 0.8) {
            className = "number numberSize blueColor";
          } else if (val > gb * 0.8 && val <= gb) {
            className = "number numberSize yellowColor";
          } else if (val > gb) {
            className = "number numberSize redColor";
          }
        }
        return className;
      };
    },

    reactTitle() {
      if (this.customerId == 66) {
        return "titleTag_baogang";
      } else {
        return "titleTag";
      }
    },

    reactIndex() {
      if (this.customerId == 66) {
        return "indexTag_baogang";
      } else {
        return "indexTag";
      }
    },

    reactName() {
      if (this.customerId == 66) {
        return "nameTag_baogang";
      } else {
        return "nameTag";
      }
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.container).outerWidth();
    let h = $(that.$refs.container).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    this.getCemsData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  //方法集合
  methods: {
    getCemsData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let that = this;
      let findCemsListUrl = CONFIG.requestName + this.$apiOpt.findCemsList;
      this.$apiUtils
        .get(findCemsListUrl, {
          customerId: this.$store.state.customerId,
          deviceName: this.emNameVal,
        })
        .then(function (data) {
          let tmpList = [
            {
              no: 0,
              name: "",
              so2: "厂区/标准",
              klw: "厂区/标准",
              nox: "厂区/标准",
            },
          ];
          data.forEach((element, n) => {
            tmpList.push({
              no: n + 1,
              name: element.deviceName,
              deviceNo: element.deviceNo ? element.deviceNo : "",
              so2: element.deviceSo2 ? element.deviceSo2 : "--",
              klw: element.deviceTdc ? element.deviceTdc : "--",
              nox: element.deviceNox ? element.deviceNox : "--",
              gbNox: element.gbNox ? element.gbNox : "--",
              gbSo2: element.gbSo2 ? element.gbSo2 : "--",
              gbTdc: element.gbTdc ? element.gbTdc : "--",
              time: that.$moment(element.time).format("YYYY-MM-DD hh:mm"),
              lon: element.longitude || 0,
              lat: element.latitude || 0,
            });
          });

          that.list = tmpList;
        });
      this.timer = setTimeout(() => {
        this.getCemsData();
      }, 1000 * 60);
    },
    clearCemsArgs() {
      this.emNameVal = "";
      this.list = [];
      this.getCemsData();
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.searchTitle {
  .el-select {
    border-radius: 2px !important;
    border: 1px solid !important;
    border-image: linear-gradient(
        90deg,
        rgba(46, 49, 255, 1),
        rgba(1, 176, 191, 1)
      )
      1 1 !important;
  }
  .el-select .select-trigger .el-input .el-input__inner {
    height: 32px !important;
    background: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.64) 0%,
      rgba(11, 10, 34, 0.55) 100%
    ) !important;
    box-shadow: 0px 0px 6px 0px #000000 !important;
    opacity: 1 !important;
    border: none !important;
  }

  .el-input {
    border-radius: 2px !important;
    border: 1px solid !important;
    border-image: linear-gradient(
        90deg,
        rgba(46, 49, 255, 1),
        rgba(1, 176, 191, 1)
      )
      1 1 !important;
  }
  .el-input .el-input__inner {
    height: 28px !important;
    background: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.64) 0%,
      rgba(11, 10, 34, 0.55) 100%
    ) !important;
    box-shadow: 0px 0px 6px 0px #000000 !important;
    opacity: 1 !important;
    border: none !important;
  }
}

.container {
  pointer-events: all;
  .cems_table {
    border: 1px solid #84aaff40 !important;
    background: #01132d40 !important;

    .numberSize {
      font-size: 23px;
      color: #99f5ff;
      display: inline-block;
      width: 60px;
    }
    .standardSize {
      font-size: 23px;
      color: #99f5ff;
      display: inline-block;
      width: 55px;
    }
    .splitTag {
      padding: 0 10px;
      color: #d8d8d8;
      font-size: 22px;
      opacity: 0.3;
    }
    .titleTag {
      font-size: 20px;
      color: #afafaf;
      display: inline-block;
      font-family: "fontNormal";
    }
    .indexTag {
      color: #afafaf;
      text-align: center;
      display: inline-block;
      width: 100%;
    }
  }
  .thClass {
    background: #01122ba6 !important;
    //border-bottom: 1px solid #cccccc28 !important;
    border-right: 1px solid #cccccc28 !important;
    border-bottom: none !important;
    margin-bottom: 2px !important;
    padding-bottom: 2px !important;
    border-top: none !important;
  }

  .thClass > .cell {
    font-size: 16px !important;
    color: #47ffddff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .thClass_ {
    background: #01122ba6 !important;
    border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass__ {
    background: #01122ba6 !important;
    border-bottom: 1px solid #cccccc28 !important;
    border-right: 1px solid #cccccc28 !important;
    margin-top: 2px !important;
    padding-top: 2px !important;
    border-top: none !important;
  }
  .thClass_baogang {
    background: transparent !important;
    border-bottom: 1px solid #cccccc28 !important;
    border-right: 1px solid #cccccc28 !important;
    margin-top: 2px !important;
    padding-top: 2px !important;
    border-top: none !important;
  }

  .thClass__ > .cell {
    font-size: 14px !important;
    color: #196d5d !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .thClass_ > .cell {
    font-size: 16px !important;
    color: #888888ff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .tdClass {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
  }
  .tdClass > .cell {
    font-size: 16px !important;
    color: #888888ff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .tdClass_ {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #0b336b40 !important;
  }

  .tdClass_ > .cell > div {
    font-size: 16px !important;
    color: #888888ff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .headTrClass {
    border: 1px solid rgba(132, 170, 255, 0.5) !important;
  }
}
</style>
<style scoped lang="scss">
.blueColor {
  color: #99f5ff !important;
}

.yellowColor {
  color: #f4c48f !important;
}

.redColor {
  color: #ff7373 !important;
}

.control-btn {
  float: right;
}
.allListBtn {
  color: #4be0ff;
  position: absolute;
  right: 50px;
  top: 50px;
}

.green-dot {
  color: #99f5ffff;
  line-height: 16px;
  font-size: 30px;
}

.red-dot {
  color: #ff7f7fff;
  line-height: 16px;
  font-size: 30px;
}

.gray-dot {
  color: #cccccccc;
  line-height: 16px;
  font-size: 30px;
}

.container {
  position: absolute;
  height: 720px;
  width: 100%;
  margin-top: 55px !important;
  padding: 10px 32px 20px 32px !important;
  pointer-events: all;
}

.searchTitle {
  display: inline-block;
  span {
    font-size: 16px;
    font-family: "fontNormal";
    color: #99f5ff;
  }
}

.self_btn {
  background-image: url("img/btn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  width: 90px;
  height: 45px;
  line-height: 40px;
  display: inline-block;
  cursor: pointer;
}

/*.self_btn:hover{
 background-image: url("img/btn_click.png");
}*/

.self_btn:active {
  background-image: url("img/btn_click.png");
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #4d4d4dff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: "fontNormal";
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
<style lang="scss" scoped>
.titleTag_baogang {
  font-size: 20px;
  color: #fff;
  display: inline-block;
  font-family: "fontNormal";
}
.indexTag_baogang {
  color: #fff;
  text-align: center;
  display: inline-block;
  width: 100%;
}
.nameTag {
  color: #afafaf;
  text-align: center;
  display: inline-block;
  width: 100%;
}
.nameTag_baogang {
  color: #fff;
  text-align: center;
  display: inline-block;
  width: 100%;
}
</style>
